// Shared status badge for jobs. Single source of truth for the
// status → variant mapping and label rendering.

import type { JobStatus } from '@gutterinv/shared';
import { Badge } from './ui/badge.js';
import { STATUS_LABEL } from '../lib/labels.js';

// All forward lifecycle stages render filled blue ('default' = bg-primary) for
// a consistent status bubble across Today / Jobs / Sidecard / Customers — the
// past-tense label is the differentiator, not the color. 'disqualified' stays
// red ('destructive') as a distinct negative off-ramp, not a forward stage.
const STATUS_VARIANT: Record<JobStatus, 'default' | 'secondary' | 'destructive' | 'warning' | 'outline'> = {
  created:          'default',
  estimated:        'default',
  quoted:           'default',
  accepted:         'default',
  scheduled:        'default',
  installed:        'default',
  invoiced:         'default',
  completed:        'default',
  disqualified:     'destructive',
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return (
    <Badge variant={STATUS_VARIANT[status] ?? 'outline'}>
      {STATUS_LABEL[status] ?? status}
    </Badge>
  );
}
